module.exports = __webpack_public_path__ + "static/Background_aplicaciones_adicionales-03a608c857f60c75b0d54801b6944d9c.jpg";